module.exports = __webpack_public_path__ + "img/tasty.976f0e64.svg";